import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCHeXa2jsHgnXoFvihiNpzIu_hyewrvFuI",
  authDomain: "derma-protec.firebaseapp.com",
  projectId: "derma-protec",
  storageBucket: "derma-protec.firebasestorage.app",
  messagingSenderId: "669963942694",
  appId: "1:669963942694:web:094daeb0b221eeb8201fe7"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth }; 